import { render, staticRenderFns } from "./materialScience_span_line.vue?vue&type=template&id=3279c511&scoped=true"
import script from "./materialScience_span_line.vue?vue&type=script&lang=js"
export * from "./materialScience_span_line.vue?vue&type=script&lang=js"
import style0 from "./materialScience_span_line.vue?vue&type=style&index=0&id=3279c511&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3279c511",
  null
  
)

export default component.exports